import HeroSection from "./HeroSection";
import BeginYourJourney from "./CtaSection";
import ShowcaseSection from "./ShowcaseSection";
import NotJustADeckSection from "./NotJustADeckSection";
import PuzzleSection from "./PuzzleSection";
import CardOfDay from "./CardOfDay";
import CardGallery from "./CardGallery";
import SutrasSection from "./SutrasSection";
import GiftLandingSection from "./GiftLandingSection";
import ConnectSection from "./ConnectSection";
import AuthorSection from "./AuthorSection";
import TestimonialsSection from "./TestimonialsSection";
import LifestyleSection from "./LifestyleSection";
import FAQSection from "./FAQSection";
import Footer from "./Footer";
import { CopyVariantProvider, useCopy } from "@/lib/copyVariant";

// Tiny visible marker so QA / testing agents can confirm which copy variant
// the page is currently rendering. Lives behind a data-testid - no UI impact.
function VariantMarker() {
  const { variant, source } = useCopy();
  return (
    <span
      data-testid="copy-variant-marker"
      data-variant={variant}
      data-variant-source={source}
      style={{
        position: "fixed",
        width: 1,
        height: 1,
        overflow: "hidden",
        clip: "rect(0 0 0 0)",
        whiteSpace: "nowrap",
        border: 0,
      }}
      aria-hidden="true"
    >
      {variant}
    </span>
  );
}

export default function LandingPage() {
  return (
    <CopyVariantProvider>
      <main className="min-h-screen bg-[#fff8f3]" data-testid="landing-page">
        <VariantMarker />
        <HeroSection />
        <ShowcaseSection />
        <LifestyleSection />
        <BeginYourJourney />
        <CardOfDay />
        <SutrasSection />
        <NotJustADeckSection />
        <CardGallery />
        <PuzzleSection />
        <AuthorSection />
        <TestimonialsSection />
        <GiftLandingSection />
        <FAQSection />
        <ConnectSection />
        <Footer />
      </main>
    </CopyVariantProvider>
  );
}
